import { render, staticRenderFns } from "./RecoverPwd.vue?vue&type=template&id=4f94d3a2&scoped=true"
import script from "./RecoverPwd.vue?vue&type=script&lang=js"
export * from "./RecoverPwd.vue?vue&type=script&lang=js"
import style0 from "./RecoverPwd.vue?vue&type=style&index=0&id=4f94d3a2&prod&lang=scss"
import style1 from "./RecoverPwd.vue?vue&type=style&index=1&id=4f94d3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f94d3a2",
  null
  
)

export default component.exports